var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 28,
    viewBox: "0 0 28 28",
    width: 28,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m18 18a7 7 0 1 0 -7-7 7 7 0 0 0 7 7zm0 3.5c-4.672 0-14 2.345-14 7v3.5h28v-3.5c0-4.655-9.328-7-14-7z",
    fill: "#1c5970",
    transform: "translate(-4 -4)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAvatar);
export default __webpack_public_path__ + "static/media/icon-avatar.70c11459f483ac21e978e27ff373c906.svg";
export { ForwardRef as ReactComponent };